// Generated by `npm run data:towed-debris` (scripts/data/towedDebris.ts): the share of the derelict gear on Maui Nui's
// reefs that was nets, from NOAA's towed divers at Maui, Molokaʻi and Lānaʻi, data/crep-towed-debris-0163745/.
// Do not edit by hand. tests/derelictGear338.test.ts builds it again.

/**
 * Of the 144 pieces of derelict fishing gear NOAA's towed divers counted on 1680 segments (392.49 km) of Maui Nui's
 * forereefs in 2005, 2006, 2008, 2010, the share in the segments whose diver's note names a net: 29 of 144; of the
 * rest, 110 noted as line, 5 other gear or unnoted (drawn as line).
 */
export const NET_SHARE = 0.201389;
